import { NavLink, useNavigate } from "react-router-dom";
import { Boxes, Home, MoreHorizontal, ScanLine, Search } from "lucide-react";

import { cn } from "@/lib/cn";

/**
 * Mobile bottom navigation (Frontend Spec §4).
 *
 * Five slots, the most frequent actions only, with Scanner in the middle and
 * raised: on a job site it is the button you press without looking.
 *
 * Hidden from `md` up, exactly where the sidebar appears. The two must switch
 * on the same number or there is a band of widths with both, or neither.
 */
const ITEMS = [
  { to: "/dashboard", label: "Accueil", icon: Home },
  { to: "/search", label: "Recherche", icon: Search },
  { to: "/inventory", label: "Inventaire", icon: Boxes },
  { to: "/more", label: "Plus", icon: MoreHorizontal },
];

export function MobileBottomNav() {
  const navigate = useNavigate();

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-surface pb-[env(safe-area-inset-bottom)] md:hidden"
      aria-label="Navigation"
    >
      <ul className="grid grid-cols-5 items-end">
        {ITEMS.slice(0, 2).map((item) => (
          <NavItem key={item.to} {...item} />
        ))}

        <li className="flex justify-center">
          <button
            type="button"
            onClick={() => navigate("/blitz")}
            className="-mt-5 flex size-14 items-center justify-center rounded-full bg-brand text-ink-inverse shadow-lg shadow-black/40 active:bg-brand-pressed"
            aria-label="Mode Blitz"
          >
            <ScanLine className="size-6" aria-hidden />
          </button>
        </li>

        {ITEMS.slice(2).map((item) => (
          <NavItem key={item.to} {...item} />
        ))}
      </ul>
    </nav>
  );
}

function NavItem({
  to,
  label,
  icon: Icon,
}: {
  to: string;
  label: string;
  icon: typeof Home;
}) {
  return (
    <li>
      <NavLink
        to={to}
        className={({ isActive }) =>
          cn(
            "flex min-h-[54px] flex-col items-center justify-center gap-0.5 px-1 py-2 text-[10px]",
            isActive ? "text-brand" : "text-ink-subtle",
          )
        }
      >
        <Icon className="size-5" aria-hidden />
        <span>{label}</span>
      </NavLink>
    </li>
  );
}
